import { Button, type ButtonProps } from "$components/button/button";
import { UnstyledLink } from "$components/link";
import { styled } from "@material-ui/core";
import type { LinkProps } from "react-router-dom";

export type LinkButtonProps = LinkProps &
  ButtonProps & {
    linkClassName?: string;
  };

/**
 * A {@link Button} that navigates via react-router. Keeps the button primitive
 * routing-agnostic — routing lives here. Disabled links follow a11y guidance:
 * https://a11y-guidelines.orange.com/en/articles/disable-elements/
 */
export const LinkButton: FC<LinkButtonProps> = ({
  to,
  replace,
  linkClassName,
  ...buttonProps
}) => {
  const visualButton = <Button {...buttonProps} />;
  if (buttonProps.disabled) {
    return (
      <UnstyledAnchor
        className={linkClassName}
        role="link"
        aria-disabled={true}
      >
        {visualButton}
      </UnstyledAnchor>
    );
  }
  return (
    <UnstyledLink to={to} replace={replace} className={linkClassName}>
      {visualButton}
    </UnstyledLink>
  );
};

const UnstyledAnchor = styled("a")({
  color: "inherit",
  textDecoration: "none",
});
